<!-- Do not change this file. -->

<template>
  <div v-if="isDebugMode">
    <!-- Offcanvas -->
    <div
      class="debugOffCanvas offcanvas offcanvas-end"
      tabindex="-1"
      id="offcanvasRight"
      aria-labelledby="offcanvasRightLabel"
    >
      <div class="offcanvas-header">
        <h5 id="offcanvasRightLabel">Debugger</h5>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body">
        <DebugAuth />
        <DebugEnv />
        <DebugDatastore />
      </div>
    </div>

    <!-- Footer Content-->
    <div class="d-flex my-auto">
      <TheBreakpoints />
      <button
        class="ms-3 nav-link text-primary my-auto"
        @click="toggleVisibility()"
      >
        Debugger
      </button>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import { mapGetters } from "vuex";
import { Offcanvas } from "bootstrap";
import DebugAuth from "@/components/debug/DebugAuth.vue";
import DebugEnv from "@/components/debug/DebugEnv.vue";
import DebugDatastore from "@/components/debug/DebugDatastore.vue";

import TheBreakpoints from "@/components/debug/TheBreakpoints.vue";
export default {
  name: "TheDebugger",
  data() {
    return {
      offCanvas: {},
      visible: true
    };
  },
  components: {
    DebugAuth,
    DebugEnv,
    DebugDatastore,
    TheBreakpoints
  },
  computed: {
    ...mapGetters(["isDebugMode"])
  },
  methods: {
    toggleVisibility() {
      this.offCanvas.toggle();
    }
  },
  mounted() {
    if (this.isDebugMode) {
      const offcanvasElement = document.querySelector(".debugOffCanvas");
      this.offCanvas = new Offcanvas(offcanvasElement);
    }
  }
};
</script>

<style scoped>
.nav-link {
  margin-top: 1px;
}
.nav-link:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
